document.addEventListener('DOMContentLoaded', () => {
    const donateMe = document.querySelector('.donatemate-app-wrapper');

    if (!donateMe) return;

    const donateImage = donateMe.querySelector('.donatemate-image');
    const donateText = donateMe.querySelector('.donatemate-text');

    if (!donateImage || !donateText) return;

    const secondP = donateText.querySelectorAll('p')[1];

    if (!secondP) return;

    donateImage.appendChild(secondP);
});


(function () {
  console.log('[VariantDesc] init');

  function updateVariantDescription() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const target = document.querySelector('[data-variant-description]');

    if (!variantInput || !target) return;

    const variantId = variantInput.value;

    if (!window.variantDescriptions) {
      target.innerHTML = '';
      return;
    }

    const html = window.variantDescriptions[variantId] || '';
    target.innerHTML = html;
  }

  function bindObserver() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    console.log('[VariantDesc] observing variant input');

    const observer = new MutationObserver(() => {
      console.log('[VariantDesc] variant input changed:', variantInput.value);
      updateVariantDescription();
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    // initial correct load
    updateVariantDescription();
  }

  function init() {
    if (typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        () => setTimeout(updateVariantDescription, 0)
      );
    }

    bindObserver();
  }

  document.addEventListener('DOMContentLoaded', init);

  // Ella AJAX safety (important)
  document.addEventListener('shopify:section:load', init);
})();